<template>
  <card
    @onRemoveItem="handleRemove"
    :item="item"
    model="pony"
    :image="imagePath"
    :url="url"
    :user="user"
  >
    <h3 v-if="item.notes" class="elr-card-subtitle">{{item.notes}}</h3>
    <div class="pony-stats-manager">
      <PonyStats :pony="item" />
      <PonyListActions :authenticated="authenticated" v-if="Object.keys(item).length" :pony="item" />
    </div>
    <PonyCardDetails :pony="item" />
  </card>
</template>

<script>
import { getImagePath } from '../../utils/helpers';
import Card from '../Card/Card';
import PonyListActions from '../PonyListActions/PonyListActions';
import PonyCardDetails from '../PonyCardDetails/PonyCardDetails';
import PonyStats from '../PonyStats/PonyStats';

export default {
  name: 'PonyCard',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    authenticated: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PonyCardDetails,
    PonyListActions,
    Card,
    PonyStats
  },
  computed: {
    imagePath() {
      return getImagePath(this.item?.image);
    },
    url() {
      return `/pony/${this.item.slug}`;
    }
  },
  methods: {
    handleRemove() {
      this.$emit('onRemove', { slug: this.item.slug });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.pony-stats-manager {
  /* border-top: 1px solid $light-grey; */
  border-bottom: 1px solid $light-grey;
}
</style>
